export const ptBr = {
  startsWith: 'Começa com',
  contains: 'Contém',
  notContains: 'Não contém',
  endsWith: 'Termina com',
  equals: 'Igual a',
  notEquals: 'Diferente de',
  noFilter: 'Sem filtro',
  lt: 'Menor que',
  lte: 'Menor ou igual a',
  gt: 'Maior que',
  gte: 'Maior ou igual a',
  dateIs: 'Data é',
  dateIsNot: 'Data não é',
  dateBefore: 'Data é antes de',
  dateAfter: 'Data é depois de',
  clear: 'Limpar',
  apply: 'Aplicar',
  matchAll: 'Corresponder a todos',
  matchAny: 'Corresponder a qualquer',
  addRule: 'Adicionar regra',
  removeRule: 'Remover regra',
  accept: 'Sim',
  reject: 'Não',
  choose: 'Escolher',
  upload: 'Enviar',
  cancel: 'Cancelar',
  completed: 'Concluído',
  pending: 'Pendente',
  fileSizeTypes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
  dayNames: ['Domingo', 'Segunda-feira', 'Terça-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sábado'],
  dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
  dayNamesMin: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  monthNames: [
    'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
    'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
  ],
  monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
  chooseYear: 'Escolher ano',
  chooseMonth: 'Escolher mês',
  chooseDate: 'Escolher data',
  prevDecade: 'Década anterior',
  nextDecade: 'Próxima década',
  prevYear: 'Ano anterior',
  nextYear: 'Próximo ano',
  prevMonth: 'Mês anterior',
  nextMonth: 'Próximo mês',
  prevHour: 'Hora anterior',
  nextHour: 'Próxima hora',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Próximo minuto',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Próximo segundo',
  am: 'AM',
  pm: 'PM',
  today: 'Hoje',
  weekHeader: 'Sem',
  firstDayOfWeek: 0,
  dateFormat: 'dd/mm/yy',
  weak: 'Fraca',
  medium: 'Média',
  strong: 'Forte',
  passwordPrompt: 'Digite uma senha',
  emptyFilterMessage: 'Nenhum resultado encontrado',
  searchMessage: '{0} resultados disponíveis',
  selectionMessage: '{0} itens selecionados',
  emptySelectionMessage: 'Nenhum item selecionado',
  emptySearchMessage: 'Nenhum resultado encontrado',
  emptyMessage: 'Nenhuma opção disponível',
  aria: {
    trueLabel: 'Verdadeiro',
    falseLabel: 'Falso',
    nullLabel: 'Não selecionado',
    star: '1 estrela',
    stars: '{star} estrelas',
    selectAll: 'Todos os itens selecionados',
    unselectAll: 'Todos os itens desmarcados',
    close: 'Fechar',
    previous: 'Anterior',
    next: 'Próximo',
    navigation: 'Navegação',
    scrollTop: 'Rolar para o topo',
    moveTop: 'Mover para o topo',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    moveBottom: 'Mover para o final',
    moveToTarget: 'Mover para destino',
    moveToSource: 'Mover para origem',
    moveAllToTarget: 'Mover todos para destino',
    moveAllToSource: 'Mover todos para origem',
    pageLabel: '{page}',
    firstPageLabel: 'Primeira página',
    lastPageLabel: 'Última página',
    nextPageLabel: 'Próxima página',
    prevPageLabel: 'Página anterior',
    rowsPerPageLabel: 'Linhas por página',
    jumpToPageDropdownLabel: 'Ir para página (dropdown)',
    jumpToPageInputLabel: 'Ir para página (input)',
    selectRow: 'Linha selecionada',
    unselectRow: 'Linha desmarcada',
    expandRow: 'Linha expandida',
    collapseRow: 'Linha recolhida',
    showFilterMenu: 'Mostrar menu de filtro',
    hideFilterMenu: 'Ocultar menu de filtro',
    filterOperator: 'Operador de filtro',
    filterConstraint: 'Restrição de filtro',
    editRow: 'Editar linha',
    saveEdit: 'Salvar edição',
    cancelEdit: 'Cancelar edição',
    listView: 'Visualização em lista',
    gridView: 'Visualização em grade',
    slide: 'Slide',
    slideNumber: '{slideNumber}',
    zoomImage: 'Ampliar imagem',
    zoomIn: 'Aumentar zoom',
    zoomOut: 'Reduzir zoom',
    rotateRight: 'Girar para a direita',
    rotateLeft: 'Girar para a esquerda'
  }
};
